import AdminEleven from "@/layouts/AdminEleven.vue";

export const checkinRoutes = [
  {
    path: "/checkin",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "checkin",
        path: "",
        component: () => import("@/views/checkin/Checkin.vue"),
        meta: {
          title: "Check-in",
          requiresAuth: true,
          requiresAdminProfile: false,
        },
      },
    ],
  },
];
